import { render, staticRenderFns } from "./AIChatting.vue?vue&type=template&id=54ba9314&scoped=true"
import script from "./AIChatting.vue?vue&type=script&lang=js"
export * from "./AIChatting.vue?vue&type=script&lang=js"
import style0 from "./AIChatting.vue?vue&type=style&index=0&id=54ba9314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba9314",
  null
  
)

export default component.exports